import React, { Component } from 'react';

//IMPORT REDUX
import { connect } from 'react-redux';
import { addModalExport } from '../../../redux/actions/ConfigFileAction'

import { groupBy } from './ConfigFunction'
import Exit from '../../../assets/svg/Exit.svg';

//IMPORT SEMANTIC COMPONENTS
import 'semantic-ui-css/semantic.min.css';
import {
    Grid,
    Segment,
    Button,
    Icon,
    Modal,
    Header,
    Image
} from 'semantic-ui-react';

// PDF
import jsPDF from 'jspdf'
import './modalExport.css'

import Excel from '../../../assets/img/excel.png';
import Adobe from '../../../assets/img/adobe.png';

import { translate } from "react-translate";

import { Currencies } from '../../../constants/Currencies';

import API from '../../../services/api';

const mapStateToProps = state => ({
    app: state.app,
    configfile: state.configfile
})

const mapActionToProps = {
    addModalExport: addModalExport
}

class ConnectedModalExport extends Component {
    constructor(props) {
        super(props);

        this.state = {
            currency: "EUR",
          }

        // Bind Redux
        this.closeModalExport = this.closeModalExport.bind(this)
        this.handleSubmitExport = this.handleSubmitExport.bind(this)

    }

    componentWillMount() {
        var self = this;
        API.getUser(this.props.app.token).then((res) => {
            let tmpResponseCurrencies = Currencies.filter(currency => currency.value == res.data.currency);
            self.setState({
                currency: tmpResponseCurrencies.length > 0 ? tmpResponseCurrencies[0].text : '€',
            })
        });
      }

    // MODAL functions
    closeModalExport() {
        this.props.addModalExport(false)
    }

    handleSubmitExport() {

        var pdf = new jsPDF('p', 'pt', 'letter');

        var margins = {
            top: 60,
            left: 50,
            width: 545
        };

        let html = ["<center>"];
        html.push("<h1>Calcul " + this.props.configfile.workTitle + "</h1>");
        html.push("<p>" + this.props.configfile.workDescription + "</p><p><a href=" + this.props.configfile.howToLink + ">" + this.props.configfile.howToText + "</a></p>  <h2><span style='color: white'>|</span></h2></br></br>")

        let tmp = this.props.configfile.calculResult.sort(function (a, b) {
            return a.groupid - b.groupid;
        });

        var o = groupBy(tmp, 'groupid');

        Object.entries(o).map((key, Mainindex) => {
            o[Mainindex] = o[Mainindex].sort(function (a, b) {
                return a.order - b.order;
            });
        })

        Object.entries(o).map((key, Mainindex) => {
            Object.entries(key[1]).map((key, Mainindex) => {
                let unit = "";
                let text = "";

                if (key[1].unit != undefined) {
                    unit = key[1].unit
                }
                if (key[1].unitApp === "%%cur%%") {
                    unit = this.state.currency
                }
                if (key[1].textChoose != undefined) {
                    text = key[1].textChoose
                }

                if (key[1].value != undefined) {
                    let textFin = text ? (text) : (key[1].value)
                    html.push("<p>" + key[1].text + " : " + textFin + " " + unit + "</p>")
                } else {
                    let textFin = text ? (text) : (key[1].variableNumValue)
                    html.push("<p>" + key[1].text + " : " + text + " " + unit + "</p>")
                }

            })
            html.push("<h2><span style='color: white'>|</span></h2>")
        })

        html.push("<h4>MYTRAVO :</h4>")
        html.push("<p>Lien vers l'application : https://play.google.com/store/apps/details?id=com.guidiyam.mytravo</p>")
        html.push("<p>Contact : contact@mytravo.net</p>")
        html.push("<p>Site : www.mytravo.net</p></center>")

        if (html[25] != undefined || html[47] != undefined) {
            //html.splice(25, 0, "<h2><span style='color: white'>|</span></h2>");
        }

        pdf.fromHTML(
            html.join("") // HTML string or DOM elem ref.
            , margins.left // x coord
            , margins.top // y coord
            , {
                'width': margins.width // max width of content on PDF
            },
            function (dispose) {
                // dispose: object with X, Y of the last line add to the PDF
                // this allow the insertion of new lines after html
                pdf.save('MyTravo.pdf');
            }
        )


        this.closeModalExport()
    }

    render() {
        const { t } = this.props;

        return (

            <div>
                <Modal
                    open={this.props.configfile.modal_export}
                    onClose={this.closeModalExport}
                    size='tiny'
                    id="modalExport"
                >
                    <Modal.Header id="modalHeader">
                        <Grid>
                            <Grid.Row>
                                <Grid.Column textAlign='center'>
                                    <Image
                                        id="modalExit"
                                        onClick={this.closeModalExport}
                                        src={Exit}
                                        floated='right' />
                                    <Header
                                        as='h2'
                                        id="modalTitle"
                                        textAlign='center'>
                                        Exporter le calcul
                                  </Header>
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </Modal.Header>
                    {
                        this.props.configfile.addToList && this.props.configfile.calculResult ? (
                            <div>
                                <Modal.Content >
                                    <Grid padded >
                                        <Grid.Row columns={2} centered style={{ margin: '20px 0' }}>
                                            {/*<Grid.Column textAlign='center' width={6}>
                                                <Segment id='exportMethod' onClick={this.handleSubmitExport}>
                                                    <Image centered src={Excel} />
                                                    <span>{t("Excel")}</span>
                                                </Segment>
                                            </Grid.Column>*/}
                                            <Grid.Column textAlign='center' width={6}>
                                              <Segment id='exportMethod' onClick={this.handleSubmitExport}>
                                                    <Image centered src={Adobe} />
                                                    <span>{t("pdf")}</span>
                                                </Segment>
                                            </Grid.Column>

                                        </Grid.Row>
                                    </Grid>
                                </Modal.Content>
                            </div>
                        ) : (
                                <Modal.Content>

                                    <Grid
                                        textAlign='center'
                                        style={{ height: '100%' }}
                                        verticalAlign='middle'>
                                        <Grid.Column>
                                            <a href='/'><Image floated='right' /></a>
                                            <Header as='h3' id="modalExportError" textAlign='center'>
                                                {t("error")}
                                            </Header>
                                            <Header as='h5' id="modalExportErrorDescription">{t("prevention")}</Header>
                                        </Grid.Column>
                                    </Grid>

                                </Modal.Content>
                            )
                    }
                </Modal>
            </div>
        )
    }
}

const ModalExport = connect(mapStateToProps, mapActionToProps)(ConnectedModalExport);
export default translate("ModalExport")(ModalExport);



// WEBPACK FOOTER //
// ./src/components/Protected/Travaux/ModalExport.jsx